<div>
  <h1>You don't have access to any organizations in this system.</h1>
  <p>Speak with your organization's administrator to be added to your organization.</p>
</div>
